import { useCallback, useMemo, useState } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import type { TranslatableLabel } from '#src/app/shared/hooks/i18n';

const RESET_LABEL_TIMER = 3000;

type ShareData = { clickedState: boolean; buttonLabel: TranslatableLabel; resolvedUrl: string };
type ShareActions = { afterShare: () => void };
type UseDefaultShareButtonResult = ModelHookResult<ShareData, ShareActions>;
type UseCopyLinkVisibleUrlButton = {
	label: TranslatableLabel;
	successLabel?: TranslatableLabel;
	url: string;
};
export function useCopyLinkVisibleUrlButton({
	label,
	successLabel,
	url,
}: UseCopyLinkVisibleUrlButton): UseDefaultShareButtonResult {
	const [clickedState, setClickedState] = useState(false);

	const afterShare = useCallback(() => {
		if (successLabel) {
			setClickedState(true);
			// Timeout to reset the style
			window.setTimeout(() => {
				setClickedState(false);
			}, RESET_LABEL_TIMER);
		}
	}, [setClickedState, successLabel]);

	const buttonLabel = useMemo(
		() => (successLabel && clickedState ? successLabel : label),
		[clickedState, successLabel, label],
	);

	const { resolveUrl } = useUtilityContext();
	const resolvedUrl = useMemo(() => {
		return resolveUrl(url);
	}, [url, resolveUrl]);

	return {
		data: { clickedState, buttonLabel, resolvedUrl },
		actions: { afterShare },
	};
}
